import { render, staticRenderFns } from "./merchantIndex.vue?vue&type=template&id=1e3c023c&scoped=true&"
import script from "./merchantIndex.vue?vue&type=script&lang=js&"
export * from "./merchantIndex.vue?vue&type=script&lang=js&"
import style0 from "./merchantIndex.vue?vue&type=style&index=0&id=1e3c023c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3c023c",
  null
  
)

export default component.exports